module.exports = __webpack_public_path__ + "static/media/file-pdf-regular.65993e7b.svg";